import type { IconProps } from './types';
import './icons.css';

export default function Back({
  width,
  height,
  className = '',
}: IconProps): React.JSX.Element {
  return (
    <svg
      width={width || 25}
      height={height || 24}
      viewBox="0 0 25 24"
      xmlns="http://www.w3.org/2000/svg"
      className={`icon icon-back ${className || ''}`}
    >
      <path
        d="M4.5 10H17.5C19.7091 10 21.5 11.7909 21.5 14C21.5 16.2091 19.7091 18 17.5 18H12.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="transparent"
      />
      <path
        d="M7.5 6L3.5 10L7.5 14"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="transparent"
      />
    </svg>
  );
}
